import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NavigateBackService } from './navigate-back.service';

@Directive({
  selector: '[appNavigateBack]',
  standalone: false
})
export class NavigateBackDirective implements OnInit, OnDestroy {
  private unregisterEventHandler?: () => void;

  constructor(
    private elementRef: ElementRef,
    private navigateBackService: NavigateBackService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.unregisterEventHandler = this.renderer.listen(this.elementRef.nativeElement, 'click', () => {
      this.navigateBackService.goBack();
    });
  }

  ngOnDestroy() {
    this.unregisterEventHandler();
  }
}
